export const BRAND = {
  name: "ProExec Virtual Solutions",
  tagline: "Virtual Executive Assistant Services",
  slogan: "Empowering your productivity. Elevating your business.",
  intro:
    "Hello and welcome. As your dedicated virtual executive assistants, we're here to streamline your tasks and boost your productivity — with a thoughtfully curated set of services and packages tailored to your journey.",
  phone: "770/609-9535",
  email: "ExecProVirtualSolutions@gmx.com",
  location: "Worldwide / Remote",
  founder: "Débora Gittens",
  founderRole: "Founder",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Packages", href: "#packages" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    tag: "01",
    title: "Email & Inbox Management",
    desc: "A calm, organized inbox — sorted, prioritized, and answered on your behalf.",
  },
  {
    tag: "02",
    title: "Calendar Scheduling",
    desc: "Intelligent scheduling and meeting prep so your days flow without friction.",
  },
  {
    tag: "03",
    title: "File & Document Organization",
    desc: "Tidy, searchable systems for everything you need at a moment's notice.",
  },
  {
    tag: "04",
    title: "Travel & Reservations",
    desc: "Flights, stays, and itineraries arranged with white-glove precision.",
  },
  {
    tag: "05",
    title: "CRM & Data Entry",
    desc: "Clean pipelines and accurate records that keep relationships warm.",
  },
  {
    tag: "06",
    title: "Basic HR & Recruiting Support",
    desc: "Sourcing, screening, and coordination to help you build your team.",
  },
  {
    tag: "07",
    title: "Budget & Financial Reporting",
    desc: "Expense tracking and clear reporting that keeps your numbers honest.",
  },
  {
    tag: "08",
    title: "Reports & Presentations",
    desc: "Polished decks, onboarding docs, and stakeholder-ready summaries.",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "We protect your time",
    body: "Your hours are the scarcest asset you own. We take the busywork off your plate so you can lead, create, and rest.",
  },
  {
    num: "02",
    title: "We work in your world",
    body: "No rigid scripts. We learn your tools, your tone, and your standards until our support feels like your own.",
  },
  {
    num: "03",
    title: "We anticipate, not react",
    body: "The best assistant solves problems before they surface. We think two steps ahead so nothing slips.",
  },
];

export const PACKAGES = [
  {
    name: "Starter Support",
    subtitle: "Organized Essentials",
    price: "$1,000",
    period: "/ month",
    hours: "Up to 20 hours / month",
    highlight: false,
    features: [
      "Email management (1 inbox)",
      "Calendar scheduling",
      "File & document organization",
      "Weekly task summary reports",
    ],
  },
  {
    name: "Growth Partner",
    subtitle: "Productivity Pro",
    price: "$1,500",
    period: "/ month",
    hours: "Up to 40 hours / month",
    highlight: true,
    features: [
      "Everything in Starter Support",
      "Travel reservation & meeting prep",
      "Basic HR & recruiting support",
      "CRM & data entry support",
      "1 monthly strategy call (30 mins)",
    ],
  },
  {
    name: "Executive Solutions",
    subtitle: "Operation Optimizer",
    price: "$1,900",
    period: "/ month",
    hours: "Up to 60 hours / month",
    highlight: false,
    features: [
      "All Growth Partner services, plus",
      "Budget & financial reporting",
      "Drafting reports & presentations",
      "Onboarding document creation",
      "Stakeholder follow-up & coordination",
      "Priority 24–48 hour response",
      "2 monthly strategy calls (30 mins)",
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I have collaborated with Ms. Gittens on two separate occasions. Each time, I experienced nothing less than exceptional service, flawless communication, and excellent organization. If you are seeking to streamline your business operations, Ms. Gittens will undoubtedly help you achieve that.",
    name: "Kenneth Qualls",
    role: "Client",
    photo: "/kenneth.jpg",
  },
  {
    quote:
      "Ms. Gittens demonstrated exceptional professionalism in helping me organize my business and expenses. She was meticulous, efficient, and a fantastic communicator, making the entire process smooth and stress-free. I highly recommend her services.",
    name: "Thato Gama",
    role: "Client",
    photo: "/thato.jpg",
  },
  {
    quote:
      "I needed help establishing my online business presence, and ProExec Virtual Solutions delivered exactly what I envisioned. What stood out most was the creativity, efficiency, and impressive knowledge of AI technology. The ability to use AI tools to enhance my business profile while maintaining a polished, professional look truly impressed me. I couldn't be happier with the outcome!",
    name: "Sarah Pratt",
    role: "Client",
    photo: "/sarah.jpg",
  },

];

export const IMAGES = {
  logo: "/pvs-oval.png",
  heroAccent:
    "https://static.prod-images.emergentagent.com/jobs/e9f24a16-12e5-4259-be21-26f75dbf5b89/images/7bf9927093eff54be2db9b1572d4e41e7d63d6d0d64423c7b6a492a3b60ba5ac.png",
  aboutPortrait:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_virtual-admin-pro-2/artifacts/z07l4qit_faa727cb-decb-406c-b775-e31f5f2b75c0.webp",
  contactAccent:
    "https://images.pexels.com/photos/14903603/pexels-photo-14903603.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=940",
};
